<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		fill="currentColor"
		class="ki ki-filter"
		viewBox="0 0 24 24"
	>
		<path
			d="M7.2 3.4C6 3.4 5 4.4 5 5.6c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c0-1.2-1-2.2-2.2-2.2zM3.1 4.6c.4-1.8 2.1-3.2 4.1-3.2s3.6 1.4 4.1 3.2H24v2H11.3c-.4 1.8-2.1 3.2-4.1 3.2S3.6 8.4 3.1 6.6H0v-2h3.1zm13.7 11.6c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2zm-4.1 1.2c.4-1.8 2.1-3.2 4.1-3.2s3.6 1.4 4.1 3.2H24v2h-3.1c-.4 1.8-2.1 3.2-4.1 3.2s-3.6-1.4-4.1-3.2H0v-2h12.7z"
		/>
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24
});
</script>
